import { render } from "./CursorLabeled.vue?vue&type=template&id=53ff71ae&scoped=true"
import script from "./CursorLabeled.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorLabeled.vue?vue&type=script&setup=true&lang=js"

import "./CursorLabeled.vue?vue&type=style&index=0&id=53ff71ae&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ff71ae"],['__file',"src/scripts/common/sideBars/design/cursors/CursorLabeled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53ff71ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53ff71ae', __exports__)) {
    api.reload('53ff71ae', __exports__)
  }
  
  module.hot.accept("./CursorLabeled.vue?vue&type=template&id=53ff71ae&scoped=true", () => {
    api.rerender('53ff71ae', render)
  })

}


export default __exports__